import { LibraryIcon } from '@heroicons/react/solid';
import {
  Avatar,
  Box,
  Button,
  Chip,
  Dropdown,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  Stack,
  Typography,
} from '@mui/joy';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { useUser } from '../../../hooks/useUser';
import useDeleteCommentMutation from '../../../mutations/deleteComment';
import EmployeeIcon from '../../../assets/icon.png';
import { MoreVert } from '@mui/icons-material';

type TCommentProps = {
  comment: {
    _id: string;
    body: string;
    createdAt: string;
    owner: {
      _id: string;
      firstName: string;
      lastName: string;
      imageUrl: string;
      personType: string;
    };
    responseToCommentId: string | null;
  };
  id: string;
  responseToLabel: string | null;
  onClickReply: (responseToCommentId: string) => void;
  onDelete: () => void;
};

const Comment = (props: Readonly<TCommentProps>) => {
  const { comment, id, onClickReply, responseToLabel } = props;
  const userQuery = useUser();
  const deleteCommentMutation = useDeleteCommentMutation();

  const user = userQuery.data;
  const isAdmin =
    user?._id === comment?.owner?._id ||
    user?.role === 'ADMIN' ||
    user?.role === 'SUPER_ADMIN';

  const onClickDelete = () => {
    if (!isAdmin) {
      return;
    }

    deleteCommentMutation.mutate({
      commentId: comment._id,
      id,
    });
    props.onDelete();
  };

  const nameLabel = `${comment?.owner?.firstName ?? 'Onbekend'} ${
    comment?.owner?.lastName ?? ''
  }`;
  const isEmployee = comment?.owner?.personType === 'Employee';
  const dateLabel = dayjs(props.comment.createdAt).fromNow();

  if (!userQuery.isSuccess) {
    return null;
  }

  return (
    <Stack spacing={1} paddingLeft={comment.responseToCommentId ? '2rem' : 0}>
      {/* Profile picture */}
      <Stack gap={0.2}>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
          gap={0.2}
        >
          <Stack direction={'row'} alignItems={'center'} gap={0.2}>
            <Link to={`/profile/${comment?.owner?._id}`} className="col-span-1">
              <Avatar src={`${comment?.owner?.imageUrl}`} alt="profile" />
            </Link>

            {/* Metadata */}
            <Stack>
              <Stack direction={'row'} gap={1}>
                <Typography>{nameLabel}</Typography>
                {isEmployee && (
                  <img
                    alt={`Schoolscool medewerker icoon`}
                    src={EmployeeIcon}
                    className="w-5 h-5"
                  />
                )}
                {responseToLabel && <Chip>Antwoord op {responseToLabel}</Chip>}
              </Stack>
              <Typography level="body-xs" sx={{ marginLeft: '.2rem' }}>
                {dateLabel}
              </Typography>
            </Stack>
          </Stack>

          {/* Post time and Delete button */}

          <Dropdown>
            <MenuButton
              slots={{ root: IconButton }}
              slotProps={{ root: { variant: 'plain', color: 'neutral' } }}
            >
              <MoreVert />
            </MenuButton>
            <Menu>
              <MenuItem onClick={() => onClickReply(comment._id)}>
                Beantwoorden
              </MenuItem>
              {isAdmin && (
                <MenuItem onClick={onClickDelete}>Verwijderen</MenuItem>
              )}
            </Menu>
          </Dropdown>

          {/* <Box>
            <Button
              variant="plain"
              onClick={() => onClickReply(comment._id)}
              size="sm"
            >
              Beantwoorden
            </Button>
            {isAdmin && (
              <Button
                loading={deleteCommentMutation.isLoading}
                size="sm"
                variant="plain"
                color="danger"
                onClick={onClickDelete}
              >
                Verwijderen
              </Button>
            )}
          </Box> */}
        </Stack>
      </Stack>

      {/* Body */}
      <Typography>{comment?.body}</Typography>
    </Stack>
  );
};

export default Comment;
